<template>
  <div class="CostHistory flex-column">
    <div class="flex-auto">
      <ATable
        ref="table"
        :loading="loading"
        hideButtonExcel
        hide-button-insert
        :data="items"
        :page-size="5"
      >
        <div slot="search" class="list-title">단가 이력 조회</div>
        <el-table-column
          class-name="cell-number"
          label="기본가"
          prop="price"
          width="70"
          :formatter="util.numberFormat"
        />
        <el-table-column
          class-name="cell-number"
          v-for="level in table_customer_level"
          width="70"
          :key="level.id"
          :label="level.code"
          :prop="level.id.toString()"
        />
        <el-table-column width="70" label="등록자" prop="created_user_name" />
        <el-table-column
          label="등록일"
          prop="created_at"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CostHistory",
  data() {
    return {
      items: [],
      loading: false,
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    visible: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters(["table_customer_level"]),
  },
  watch: {
    visible(id) {
      if (id === this.data.id) this.loadData();
    },
  },
  methods: {
    async loadData() {
      if (!this.data.price.id) {
        return;
      }
      this.loading = true;
      const res = await this.api.listHistoryTableId(
        "product_price",
        this.data.price.id
      );
      this.items = this.organizeHistory(res.data);
      this.loading = false;
    },
    /** 이력을 정리하여 item으로 반환 */
    organizeHistory(items) {
      let res = [];
      if (items.length < 1) {
        return res;
      }
      for (let i = 0; i < items.length; i++) {
        let item = {
          flag: items[i].flag,
          created_at: items[i].created_at,
          created_user_name: items[i].created_user_name,
        };
        switch (item.flag) {
          case "C":
            item.price = items[i].data.price;
            items[i].data.customers.forEach((c) => {
              item[c.customer_level_id] = this.getPrice(c);
            });
            break;
          case "U":
            if (items[i].data.price) {
              const price = items[i].data.price.new;
              item.price = price ? price : 0;
            }
            if (items[i].data.customers) {
              items[i].data.customers.forEach((c) => {
                let customer_level = this.data.price.customers.find(
                  (cl) => cl.id.toString() === c.id.toString()
                );
                if (customer_level) {
                  item[customer_level.customer_level_id] = this.getPrice(c);
                } else {
                  /*
                    기본가는 price.price에 값이 있어 여기서는 상관 없음
                    그 외 단가 값이 삭제되는 경우 c.customer_level_id에는 string 타입으로 저장되며,
                    그 외 단가 값이 추가되는 경우 c.customer_level_id에는 object 타입으로 저장됨
                    ex) 삭제시 => {"customers": [{"id": "646", "deleted": true, "customer_level_id": "1"}]}
                                  └>수도권 단가 값이 0으로 저장되는 경우
                    ex) 추가시 => {"customers": [{"customer_level_id": {"old": null, "new": 1}, "price": {"old": null, "new": 123}, "ratio_flag": {"old": null, "new": "N"}, "id": "646"}]}
                                  └>수도권 단가 값이 123으로 저장되는 경우
                  */
                  if (typeof c.customer_level_id === "string")
                    item[c.customer_level_id] = 0;
                  else {
                    item[c.customer_level_id.new] = this.getPrice(c);
                  }
                }
              });
            }
            break;
        }
        res.push(item);
      }
      return res;
    },
    getPrice(item) {
      let price = item.price;
      let ratio_flag = item.ratio_flag;
      if (typeof item.price === "object") {
        price = item.price.new;
      }
      if (typeof item.ratio_flag === "object") {
        ratio_flag = item.ratio_flag.new;
      }
      if (price) {
        if (ratio_flag === "Y") {
          return "" + price + "%";
        } else {
          return this.util.addComma(price);
        }
      } else {
        //요율만 변경됨
        if (ratio_flag === "Y") {
          return "요율";
        } else {
          return "단가";
        }
      }
    },
  },
};
</script>
